<rl-please-wait *ngIf="busy" [disable]="true"></rl-please-wait>
<div class="lms-assignment">
    <h1 class="page-header">{{'quickStart.asgmt.title' | translate}}</h1>
    <p class="semi-bold">{{'quickStart.asgmt.description' | translate}}</p>
    <!-- <div *ngIf="allowSelectAsgmt && activeView != 'CREATE'" class="border-bottom MarginItem">
        <h2 (click)="toggleView('SELECT')" class="title mid-title" [ngClass]="{'toggle-displayed' : activeView=='SELECT', 'title-link' : asgmts?.length}" id="display-existing-assignments" attr.aria-expanded="{{activeView=='SELECT'}}" role="button" [rlAria]="'quickStart.asgmt.header.selectExisting' | translate" [rlTabIndex]> 
            {{'quickStart.asgmt.header.selectExisting' | translate}}
            <span class="collapse-block-icon">
                <i class="fa fa-angle-right"></i>
            </span>
        </h2>
    </div>    
    <h2 *ngIf="activeView != 'SELECT'" (click)="isItOnlyOption() ? toggleView('CREATE') : false" class="title mid-title title-link" [ngClass]="activeView=='CREATE' ? 'toggle-displayed' : 'link-toggle-hidden'" id="create-new-assignment" attr.aria-expanded="{{activeView=='CREATE'}}" role="button" [rlAria]="'quickStart.asgmt.header.createNew' | translate" [rlTabIndex]>
        {{'quickStart.asgmt.header.createNew' | translate}}
        <span class="collapse-block-icon">
            <i class="fa fa-angle-right"></i>
        </span>
    </h2> -->
    <div [hidden]="activeView != 'SELECT'">
        <rl-please-wait *ngIf="!asgmts"></rl-please-wait>
        <ol *ngIf="asgmts?.length" class="decimal">
            <li *ngFor="let a of asgmts; let i = index">
                <button (click)="busy=true;linkAssignmentToLTI(a.id)" class="btn btn-link no-padding" [id]="'asgmt-link-' + i" role="button" [tooltip]="a.title" [rlAria] [rlTabIndex]>
                    {{a.title}}
                </button>
            </li>
        </ol>
        <span *ngIf="!asgmts?.length">not found</span>
    </div>
    <div [hidden]="activeView != 'CREATE'" class="lms-create-assignment">
        <ng-container *ngIf="lists?.length > 1">
            <rl-please-wait *ngIf="loadList"></rl-please-wait>
            <rl-back-button *ngIf="isListSelected && !hideBackToSelectList" (onClick)="isListSelected = false"></rl-back-button>
            <div *ngIf="!isListSelected" class="justify-content ie-inline flex-wrap lms-create-assignment-options">
                <form class="form-flex editable-content">
                    <div class="form-flex-row">
                        <div class="form-flex-label">
                            <label for="quick-start-asgmt-select-list">Select list:</label>
                        </div>
                        <div class="form-flex-input">
                            <select class="form-control" [id]="'quick-start-asgmt-select-list'" [(ngModel)]="selectedListId" attr.aria-required="true" name="selectedList">
                                <option *ngFor="let l of lists" [value]="l.id">{{l.name}}</option>
                            </select>
                        </div>
                    </div>
                </form>
                <button (click)="selectList()" class="btn btn-link groovy-btn reversed" id="'quick-start-asgmt-select-list-next'" [rlAria]="'btn.next' | translate" [rTabIndex]>
                    {{'btn.next' | translate}}
                    <i class="fa fa-chevron-right"></i>
                </button>
            </div>
        </ng-container>
        <div class="lms-create-assignment-form" *ngIf="isListSelected && !loadList" class="flex-basis">
            <rl-add-new-item class="display-contents" [data]="data" [showDefaultSection]="true" (onSelectTab)="hideBackToSelectList = $event"></rl-add-new-item>
        </div>
    </div>
</div>
